import React from "react";
import Footer from "../Footer";
import Navbar from "../Navbar";

const PrivacyPolicy = () => {
  return (
    <>
<Navbar/>
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.date}>Effective Date: 29/06/2025</p>
      </div>

      <div style={styles.content}>
        {sections.map((section, i) => (
          <div key={i} style={styles.card}>
            <h2 style={styles.sectionTitle}>{section.title}</h2>
            <p style={styles.sectionText}>{section.text}</p>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </>
  );
};

const sections = [
  {
    title: "1. Information We Collect",
    text: `At Pearl Tours & Travels, we are committed to safeguarding your personal information. When you fill out our inquiry forms, subscribe to newsletters, or contact us directly, we may collect the following:
- Full Name
- Email Address
- Phone Number
- Travel Preferences (destinations, dates, group size, etc.)
- Any other information you voluntarily provide
  
We do not collect payment information or sensitive personal documents through our website.`,
  },
  {
    title: "2. How We Use Your Information",
    text: `We use the information collected from you for the following purposes:
- To respond to your inquiries and provide customized travel assistance
- To send confirmations, updates, and travel-related communication
- To improve our website and services based on your feedback
- For customer service and internal record-keeping
  
We do not sell, rent, or share your personal data with third-party marketers or advertisers.`,
  },
  {
    title: "3. Cookies & Analytics",
    text: `Our website may use cookies and third-party analytics tools like Google Analytics to improve your browsing experience. These tools help us understand:
- How users interact with our site
- Which pages are most visited
- General website traffic and trends

Cookies are small text files stored on your browser. You can choose to disable cookies through your browser settings, though this may affect certain site functionalities.`,
  },
  {
    title: "4. Data Security",
    text: `We prioritize the safety of your personal data. Reasonable security measures are in place to protect against unauthorized access, alteration, or disclosure. While we strive to use commercially acceptable means to protect your data, no method of online transmission or storage is 100% secure.`,
  },
  {
    title: "5. Your Rights & Choices",
    text: `You have the right to:
- Access the personal data we hold about you
- Request correction of incorrect or outdated information
- Request deletion of your data
  
To exercise any of these rights, please contact us at the details below. We will respond within a reasonable timeframe.`,
  },
  {
    title: "6. Third-Party Links",
    text: `Our website may contain links to third-party sites such as travel blogs, airline websites, or booking platforms. Once you leave our site, we are not responsible for the content or privacy practices of those websites.`,
  },
  {
    title: "7. Policy Updates",
    text: `This privacy policy may be updated from time to time to reflect changes in our practices or legal obligations. We encourage you to periodically review this page for the latest information.`,
  },
{
  title: "8. Contact Us",
  text: `If you have any questions, concerns, or requests regarding your personal data or this Privacy Policy, feel free to contact us:\n
📧 Email: pearltoursandtravelsangli@gmail.com\n
📱 Mobile: +91-73034 55505\n
☎️ Phone: 0233-2305955\n
📍 Address: Pearl Tours & Travels, Sangli, Maharashtra, India`,
}

];


const styles = {
  page: {
    backgroundColor: "white",
    minHeight: "100vh",
    padding: "40px 20px",
    color: "#fff",
    fontFamily: "Segoe UI, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: "40px",
  },
  title: {
    color: "#64192E",
    fontSize: "36px",
    marginBottom: "10px",
  },
  date: {
    color: "#ccc",
    fontSize: "14px",
  },
  content: {
    maxWidth: "900px",
    margin: "0 auto",
  },
  card: {
    backgroundColor: "#ccc",
    padding: "25px",
    borderRadius: "12px",
    marginBottom: "20px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
    transition: "transform 0.2s",
  },
  sectionTitle: {
    fontSize: "20px",
    color: "#64192E",
    marginBottom: "10px",
  },
sectionText: {
  fontSize: "16px",
  color: "black",
  whiteSpace: "pre-line",  // This makes \n work
},

};

export default PrivacyPolicy;
